import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	openLabel: {
		id: 'servicedesk-customer-permissions.common.open-label',
		defaultMessage: 'Open',
		description: 'Label for OPEN customer access to the project, i.e. all customers can access',
	},
	openDescription: {
		id: 'servicedesk-customer-permissions.common.open-description',
		defaultMessage: 'Anyone can submit requests to this project.',
		description: 'Description of team managed project',
	},
	restrictedLabel: {
		id: 'servicedesk-customer-permissions.common.restricted-label',
		defaultMessage: 'Restricted',
		description:
			'Label for RESTRICTED customer access to the project, i.e. only a few customers can access',
	},
	restrictedDescription: {
		id: 'servicedesk-customer-permissions.common.restricted-description',
		defaultMessage: 'Only people directly invited to this project can submit requests.',
		description: 'Description of the restricted access',
	},
	placeholder: {
		id: 'servicedesk-customer-permissions.common.placeholder',
		defaultMessage: 'Choose an access level',
		description: 'Placeholder text for the channel access select dialog.',
	},
});
